// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c19l\\+DEd{display:grid;grid-template-columns:repeat(2,1fr);grid-gap:max(.5rem,min(1.04vw,1.25rem));gap:max(.5rem,min(1.04vw,1.25rem))}@media(max-width:1023.98px){.c19l\\+DEd{grid-template-columns:repeat(1,1fr)}.c19l\\+DEd .o5aQa7Mn{height:max(17.13rem,min(25.52vw,30.63rem))}}@media(max-width:667.98px){.c19l\\+DEd .GtNEtSsN{width:100%}.c19l\\+DEd .GtNEtSsN>div{flex-grow:1}.c19l\\+DEd .GtNEtSsN>div>div>div{display:flex;justify-content:space-between}}.o5aQa7Mn{height:100%;-o-object-fit:cover;object-fit:cover;-o-object-position:top;object-position:top;width:100%}@media(max-width:667.98px){.o5aQa7Mn{order:2}}.rtoPMUOf{background-color:#f5f6ff;color:#434343;padding:max(1rem,min(2.08vw,2.5rem))}@media(max-width:667.98px){.rtoPMUOf{order:1}}.rtoPMUOf>*+*{margin-top:1.5rem}.H3TzlHg8{font-weight:700}.KBIJJ9Nb{font-weight:500}.H3TzlHg8,.KBIJJ9Nb{font-size:max(1rem,min(1.04vw,1.25rem));line-height:1.4;max-width:70ch}.eNaL0QKk{font-size:max(.75rem,min(.73vw,.88rem));font-weight:500;line-height:1.4;opacity:.5}.rtoPMUOf,.o5aQa7Mn{border-radius:max(1.25rem,min(2.08vw,2.5rem))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"container": "c19l+DEd",
	"img": "o5aQa7Mn",
	"btn": "GtNEtSsN",
	"card": "rtoPMUOf",
	"cardTextLg": "H3TzlHg8",
	"cardTextSm": "KBIJJ9Nb",
	"cardHint": "eNaL0QKk"
};
module.exports = ___CSS_LOADER_EXPORT___;
